<template lang="pug">
  .row
    .col-12
      header.mb-4
        h1#tittle {{$route.name}}
    .col-12
      form(@submit.prevent="carga")
        b-card(border-variant="primary" header-bg-variant="primary" header-text-variant="white")
          template(v-slot:header)
              h5.text-white.m-0 Carga masiva
          .row
            .col-12
              ul
                li Cargue un CSV con los campos Rut, Nombres, Apellidos, Correo y Contraseña.
                  a(:href="require('../assets/ejemplo.csv')" download="Ejemplo.csv") (Descargar Ejemplo)
                li Seleccione el curso que estas cuentas tendrán asignado. Los usuarios que existan previamente solo se les agregará el curso seleccionado.
                li Se validará el formato de los rut y correos y si hay inconsistencia o error en la carga se informará antes de cargar cualquier dato.
            .col-1
            .col-10
              b-alert(
                v-model="alertError"
                variant="danger"
                dismissible
              )
                center
                  h5.alert-heading Error en la carga
                  hr
                  pre {{alertErrorMsj}}
                  p Ningún dato fue cargado. Corrija el dato e intente nuevamente.
              b-alert(
                v-model="alertWarning"
                variant="warning"
                dismissible
              ) {{alertWarningMsj}}
              b-alert(
                v-model="alertSuccess"
                variant="success"
                dismissible
              )
                center
                  h5.alert-heading Carga exitosa
                  hr
                  p(v-if="countAccount>1") Felicitaciones, se han cargado correctamente {{countAccount}} cuentas de usuarios.
                  p(v-if="countAccount===1") Felicitaciones, se ha cargado correctamente {{countAccount}} cuenta de usuario.
            .form-group.col-lg-6(style="padding-top:16px")
              label(style="margin-bottom:10px;") Cursos
              multiselect(
              v-model="form.course"
              :options="formatedListCourses"
              :multiple="false"
              label="title"
              placeholder="Seleccione"
              )
            .form-group.col-lg-6
              label Archivo
              b-form-file.form-control(
                class="mt-3"
                placeholder="Subir archivo csv..."
                drop-placeholder="Soltar archivo csv aqui..."
                :disabled="!form.course"
                accept=".csv"
                ref="file"
                browse-text="Examinar"
                @change="selectFile")
              p {{form.course}}
            .form-group.form-check.px-10
              input.form-check-input(type="checkbox" id="change-pass" v-model="form.isPasswordChange")
              label.form-check-label(for="change-pass") Cambio contraseña primer login
            .col-md-12
              .col-lg-3.pull-right
                button.button(type="submit" v-if="form.course && file != null" id="buttonCargar") Cargar
                button.button(v-else id="buttonCargarDisable") Cargar
</template>
<script>
// @ is an alias to /src
import DefaultLayout from '@/layouts/DefaultLayout'
import { appisElearning, appisAmulenCore } from '../utils/axiosInstances'
export default {
  name: 'addCsvUsers',
  data () {
    return {
      form: {
        client: localStorage.getItem('clientId'),
        course: null,
        isPassWordChange: false
      },
      clientLogin: localStorage.getItem('clientName'),
      formatedListCourses: [],
      file: null,
      alertErrorMsj: '',
      alertWarningMsj: '',
      alertError: false,
      alertWarning: false,
      alertSuccess: false,
      countAccount: 0
    }
  },
  methods: {
    selectFile (event) {
      this.file = event.target.files[0]
    },
    precarga () {
      this.arrayCSV = []
      const formatcurso = this.form.course.id
      return new Promise((resolve) => {
        this.$papa.parse(this.file, {
          header: true,
          complete: async (results) => {
            this.columns = results.data.filter((csv) => csv.Rut || csv.Correo || csv.Nombres || csv.Apellidos || csv.Password)
            let dateUpdate = false
            if (!this.form.isPasswordChange || this.form.isPassWordChange === '' || this.form.isPassWordChange === undefined) {
              dateUpdate = true
            }
            this.arrayCSV = this.columns.map(dataCsv => {
              const today = new Date()
              const dateDiff = new Date(today)
              // Suma dos días a la fecha de hoy
              dateDiff.setDate(today.getDate() + 2)
              const data = {
                name: dataCsv.Nombres,
                lastname: dataCsv.Apellidos,
                email: dataCsv.Correo,
                password: dataCsv.Password,
                rut: dataCsv.Rut,
                client: '57e85c7e8276bb00110a5091',
                permissions: {
                  elearning: [formatcurso]
                }
              }
              if (dateUpdate) {
                data.updatedAt = dateDiff
              }
              return data
            })
            resolve(this.arrayCSV)
          }
        })
      })
    },
    async carga () {
      const parsedData = await this.precarga(this.file)
      let formatedOnObject = ''
      let formateArrayCsv = ''
      this.countAccount = 0
      // Formatos validos de campos
      const regexpRut = /^\d{1,2}(?:\.\d{1,3}){2}-[\dkK]$/
      const regexpEmail = /^([a-zA-Z0-9_\-.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/
      const regexNamesLastname = /^.{2,25}$/
      const regexPassword = /^.{4,8}$/
      // Validaciones segun cantidad de usuarios en csv
      if (parsedData.length === 1) {
        this.countAccount = 1
        const dataUpdate = []
        // Validar campos
        const validRut = regexpRut.test(parsedData[0].rut)
        const validEmail = regexpEmail.test(parsedData[0].email)
        const validNames = regexNamesLastname.test(parsedData[0].name)
        const validLastnames = regexNamesLastname.test(parsedData[0].lastname)
        const validPassword = regexPassword.test(parsedData[0].password)
        // Validacion si esta en formatos
        if (validRut && validEmail && validNames && validLastnames && validPassword) {
          // convertir a string, para dar formato a datos parseados
          formateArrayCsv = JSON.stringify(parsedData).replace('[{', '{').replace('}]', '}')
          // se vuelve a parsear ya con los datos correctos
          formatedOnObject = JSON.parse(formateArrayCsv)
          const response = await appisAmulenCore({
            method: 'post',
            url: '/signup',
            data: formatedOnObject
          })
          // Validaciones segun post response
          if (response.data.success === false) {
            const message = response.data.message
            if (message === 'User already exist with the same client') {
              // Extraer los datos del usuario por rut y cliente
              const urlRut = '/user/rut-client?rut='.concat(parsedData[0].rut, '&client=', parsedData[0].client)
              const responseGetRut = await appisAmulenCore({
                method: 'get',
                url: urlRut
              })
              if (responseGetRut.data.message.doc) {
                const docResponsefirst = responseGetRut.data.message.docs[0]
                let countCourse = 0
                if (docResponsefirst.permissions.elearning.length) {
                  docResponsefirst.permissions.elearning.forEach(element => {
                    if (element === this.form.course.id) {
                      countCourse = countCourse + 1
                    }
                  })
                }
                if (countCourse === 0) {
                  dataUpdate.push({
                    id: docResponsefirst.id,
                    permissions: {
                      elearning: [this.form.course.id]
                    }
                  })
                  const ur3 = '/user/permissions'
                  const responsePut = await appisAmulenCore({
                    method: 'post',
                    url: ur3,
                    data: dataUpdate[0]
                  })
                  if (responsePut.data.success === true) {
                    this.alertSuccess = true
                  }
                } else {
                  this.alertSuccess = true
                }
              } else {
                // Extraer los datos del usuario por email y cliente
                const urlEmail = '/user/rut-client?email='.concat(parsedData[0].email, '&client=', parsedData[0].client)
                const responseGetEmail = await appisAmulenCore({
                  method: 'get',
                  url: urlEmail
                })
                const docResponse = responseGetEmail.data.message.docs[0]
                let countCourse = 0
                if (docResponse.permissions.elearning.length) {
                  docResponse.permissions.elearning.forEach(element => {
                    if (element === this.form.course.id) {
                      countCourse = countCourse + 1
                    }
                  })
                }
                if (countCourse === 0) {
                  dataUpdate.push({
                    id: docResponse.id,
                    permissions: {
                      elearning: [this.form.course.id]
                    }
                  })
                  const ur3 = '/user/permissions'
                  const responsePut = await appisAmulenCore({
                    method: 'post',
                    url: ur3,
                    data: dataUpdate[0]
                  })
                  if (responsePut.data.success === true) {
                    this.alertSuccess = true
                  }
                } else {
                  this.alertSuccess = true
                }
              }
            }
          } else {
            this.alertSuccess = true
          }
        } else {
          if (!validRut && !validEmail && !validPassword && !validNames && !validLastnames) {
            this.alertError = true
            this.alertErrorMsj = 'Error en fila 1: Ningún dato tiene el formato correcto \n Formatos permitidos: \n Ejemplo Nombres: "Luis Miguel" \n Ejemplo Apellidos: "Jara Gonzalez" \n Ejemplo Correo: "usuario@escaleno.cl" \n Ejemplo Password: "123abck8" \n Ejemplo Rut: "11.111.111-1"'
          } else if (!validEmail) {
            this.alertError = true
            this.alertErrorMsj = 'Error en fila 1: Email no trae el formato correcto (ej: usuario@escaleno.cl)'
          } else if (!validRut) {
            this.alertError = true
            this.alertErrorMsj = 'Error en fila 1: Rut no trae el formato correcto (ej: 11.111.111-1)'
          } else if (!validPassword) {
            this.alertError = true
            this.alertErrorMsj = 'Error en fila 1: Password no trae el formato correcto (ej: 123adc45)'
          } else if (!validNames) {
            this.alertError = true
            this.alertErrorMsj = 'Error en fila 1: Nombres no trae el formato correcto (ej: Luis)'
          } else if (!validLastnames) {
            this.alertError = true
            this.alertErrorMsj = 'Error en fila 1: Apellidos no trae el formato correcto (ej: Gonzalez Muñoz)'
          }
        }
      } else if (parsedData.length > 1) {
        this.countAccount = parsedData.length
        // let
        let totalSuccess = 0
        const parsedDataR = parsedData.reverse()
        for (let i = 0; i < this.countAccount; i++) {
          // Validacion de formato en cada campo
          const element = parsedDataR[i]
          const validRut = regexpRut.test(element.rut)
          const validEmail = regexpEmail.test(element.email)
          const validNames = regexNamesLastname.test(element.name)
          const validLastnames = regexNamesLastname.test(element.lastname)
          const validPassword = regexPassword.test(element.password)
          if (validRut && validNames && validEmail && validLastnames && validPassword) {
            // Formateo para para post
            formateArrayCsv = JSON.stringify(element).replace('[{', '{').replace('}]', '}')
            formatedOnObject = JSON.parse(formateArrayCsv)
            const responsePost = await appisAmulenCore({
              method: 'post',
              url: '/signup',
              data: formatedOnObject
            })
            if (!responsePost.data.success) {
              if (responsePost.data.message === 'User already exist with the same client') {
                // Get de datos de usuarios por cliente y rut
                const urlRut = '/user/rut-client?rut='.concat(parsedDataR[i].rut, '&client=', parsedDataR[i].client)
                const responseGetRut = await appisAmulenCore({
                  method: 'get',
                  url: urlRut
                })
                if (responseGetRut.data.message.docs.length) {
                  const updateGetRut = []
                  const docResponse = responseGetRut.data.message.docs[0]
                  let countCourse = 0
                  if (docResponse.permissions.elearning.length) {
                    docResponse.permissions.elearning.forEach(element => {
                      if (element === this.form.course.id) {
                        countCourse = countCourse + 1
                      }
                    })
                    if (countCourse === 0) {
                      updateGetRut.push({
                        id: docResponse.id,
                        permissions: {
                          elearning: [this.form.course.id]
                        }
                      })
                      const ur3 = '/user/permissions'
                      const responsePut = await appisAmulenCore({
                        method: 'post',
                        url: ur3,
                        data: updateGetRut[0]
                      })
                      if (responsePut.data.success) totalSuccess = totalSuccess + 1
                      if (responsePut.data.message === 'cliente encontrado pero no actualizado') totalSuccess = totalSuccess + 1
                    } else {
                      totalSuccess = totalSuccess + 1
                    }
                  }
                } else {
                  const updateGetEmail = []
                  // Extraer los datos del usuario por email y cliente
                  const urlEmail = '/user/rut-client?email='.concat(parsedDataR[i].email, '&client=', parsedDataR[i].client)
                  const responseGetEmail = await appisAmulenCore({
                    method: 'get',
                    url: urlEmail
                  })
                  const docResponse = responseGetEmail.data.message.docs[0]
                  let countCourse = 0
                  if (docResponse.permissions.elearning.length) {
                    docResponse.permissions.elearning.forEach(element => {
                      if (element === this.form.course.id) {
                        countCourse = countCourse + 1
                      }
                    })
                  }
                  if (countCourse === 0) {
                    updateGetEmail.push({
                      id: docResponse.id,
                      permissions: {
                        elearning: [this.form.course.id]
                      }
                    })
                    const ur3 = '/user/permissions'
                    const responsePut = await appisAmulenCore({
                      method: 'post',
                      url: ur3,
                      data: updateGetEmail[0]
                    })
                    if (responsePut.data.success) totalSuccess = totalSuccess + 1
                    if (responsePut.data.message === 'cliente encontrado pero no actualizado') totalSuccess = totalSuccess + 1
                  } else {
                    totalSuccess = totalSuccess + 1
                  }
                }
              }
            } else {
              totalSuccess = totalSuccess + 1
            }
          } else {
            const row = this.countAccount + 1
            if (!validRut && !validEmail && !validPassword && !validNames && !validLastnames) {
              this.alertError = true
              this.alertErrorMsj = 'Error en fila '.concat(row - i, ': Ningún dato tiene el formato correcto \n Formatos permitidos: \n Ejemplo Nombres: "Luis Miguel" \n Ejemplo Apellidos: "Jara Gonzalez" \n Ejemplo Correo: "usuario@escaleno.cl" \n Ejemplo Password: "123abck8" \n Ejemplo Rut: "11.111.111-1"')
            } else if (!validEmail) {
              this.alertError = true
              this.alertErrorMsj = 'Error en fila '.concat(row - i, ': Email no trae el formato correcto (ej: usuario@escaleno.cl)')
            } else if (!validRut) {
              this.alertError = true
              this.alertErrorMsj = 'Error en fila '.concat(row - i, ': Rut no trae el formato correcto (ej: 11.111.111-1)')
            } else if (!validPassword) {
              this.alertError = true
              this.alertErrorMsj = 'Error en fila '.concat(row - i, ': Password no trae el formato correcto (ej: 123adc45)')
            } else if (!validNames) {
              this.alertError = true
              this.alertErrorMsj = 'Error en fila '.concat(row - i, ': Nombres no trae el formato correcto (ej: Luis)')
            } else if (!validLastnames) {
              this.alertError = true
              this.alertErrorMsj = 'Error en fila '.concat(row - i, ': Apellidos no trae el formato correcto (ej: Gonzalez Muñoz)')
            }
          }
        }
        if (totalSuccess === this.countAccount && totalSuccess !== 0) {
          this.alertSuccess = true
        }
      } else {
        this.alertError = true
        this.alertErrorMsj = 'Error fila 1: Debe ingresar "Rut"'
      }
    },
    async getListCourses () {
      this.formatedListCourses = []
      const response = await appisElearning.get('/course')
      this.allListCourses = response.data
      this.appsElearning = response.data
      this.appsElearning.map(async courses => {
        this.formatedListCourses.push({
          title: courses.title,
          id: courses.courseId
        })
      })
    }
  },
  created () {
    this.$emit('update:layout', DefaultLayout)
  },
  async mounted () {
    await this.getListCourses()
  }
}

</script>

<style lang="stylus" scoped>
  .button
    border: none
    position: relative
    border-radius: 6px
    height: 50px;
    width: 90%
    left: 5%
    right: 5%
  #buttonCargar
    background-color: #43ADE1
    color: white
  #buttonCargar:hover
    background-color: #2D9CD3
  #buttonCargarDisable
    cursor: not-allowed
    background-color: #A0A0A0
    color: white
  #tittle
    color: #43ADE1
</style>
